import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { SelectSignaturePreferenceForm } from '../forms'
import { useHistory, Redirect } from 'react-router-dom'
import { selectors } from '../../reducer'
import * as actions from '../../actions'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Path, AccountAudience } from 'config/portal'
import { selectors as globalSelectors } from 'global-reducer'
import { isEmpty } from 'lodash'

const propTypes = {
  completeServicesAgreementForm: Types.completeAddendumForm,
  setCompleteServicesAgreementForm: PropTypes.func.isRequired,
  currentUser: Types.user.isRequired,
  addendumServicesAgreementHash: PropTypes.object,
}

const defaultProps = {
  completeServicesAgreementForm: {
    signingMethod: '',
  },
}

function SelectSignaturePreferenceView({
  completeServicesAgreementForm,
  setCompleteServicesAgreementForm,
  currentUser,
  addendumServicesAgreementHash,
}) {
  const history = useHistory()
  const isPlanFiduciary =
    currentUser.accountAudience === AccountAudience.PLAN_FIDUCIARY

  if (isEmpty(addendumServicesAgreementHash) && !isPlanFiduciary)
    return <Redirect to={Path.ADD_NEW_BD_ADDENDUM} />

  const handleSubmit = (values) => {
    setCompleteServicesAgreementForm(values)

    history.push({
      pathname: Path.REVIEW_AND_SUBMIT_BD_ADDENDUM,
      state: {
        search: history.location.state?.search,
      },
    })
  }

  return (
    <div className="card full-height complete-services-agreement-view">
      <div className="complete-services-agreement-form-container">
        <div className="form-masthead">
          <h2>Next, select your signature preference.</h2>
        </div>
        <div className="form-section form-section--with-top-border">
          <SelectSignaturePreferenceForm
            initialValues={completeServicesAgreementForm}
            onSubmit={handleSubmit}
            accountAudience={currentUser.accountAudience}
          />
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    completeServicesAgreementForm:
      selectors.completeServicesAgreementForm(state),
    currentUser: globalSelectors.currentUser(state),
    addendumServicesAgreementHash:
      selectors.addendumServicesAgreementHash(state),
  }
}

const mapDispatchToProps = {
  setCompleteServicesAgreementForm: actions.setCompleteServicesAgreementForm,
  resetErisapediaSearches: actions.resetErisapediaSearches,
}

SelectSignaturePreferenceView.propTypes = propTypes
SelectSignaturePreferenceView.defaultProps = defaultProps

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SelectSignaturePreferenceView
)
